<!-- @format -->

<template>
  <div v-if="options">
    <div class="d-flex align-items-center">
      <div>
        <h4 class="mb-0" v-if="options.length > 0">
          {{ options[0].cate.title }}
        </h4>
        <h4 v-else>暂无文章</h4>
      </div>
    </div>
    <!-- collapse -->
    <!--    <app-collapse id="faq-payment-qna" accordion type="margin" class="mt-2">-->
    <!--      <app-collapse-item v-for="(data, index) in options" :key="index" :title="data.title">-->
    <!--        <div v-html="data.content"></div>-->
    <!--      </app-collapse-item>-->
    <!--    </app-collapse>-->
    <b-card class="mt-2" v-for="(categoryObj, categoryName) in options" :key="categoryName.id" :title="categoryObj.title">
      <b-card-body v-if="categoryObj.content">
        <div v-html="categoryObj.content"></div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { BAvatar, BCard, BCardBody } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    BAvatar,
    AppCollapseItem,
    AppCollapse,
    BCard,
    BCardBody,
  },
  props: {
    options: {
      type: [Array, Object],
      default: () => {},
    },
  },
  witch: {},
  methods: {
    ceshi() {
      console.log(this.options)
    },
  },
  mounted() {
    setTimeout(() => {}, 2000)
  },
}
</script>
